import React from 'react';
import StyledSection from "../../styles/StyledSection";

const About = () => (
    <StyledSection>
        <div className="about">
            Radiomics is an emerging, translational field of research which leverages computational techniques to
            extract information from routinely-acquired medical images. The Radiomics for Radiotherapy Research (R3)
            Initiative within Princess Margaret Cancer Centre’s Radiation Medicine Program (RMP) was established to
            explore and establish the clinical utility of Radiomics for precision radiation medicine. We envision that
            retrospective image datasets combined with the development of innovative analysis methods will yield novel
            imaging markers and therapeutic approaches that can be tested in prospective clinical trials. The R3
            Initiative aims to accelerate progress toward achieving these goals through coordination of resources and
            sharing of expertise.
        </div>
    </StyledSection>
);

export default About;
